


























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import transportcolumns from './transport-columns';
import ViewTransport from './view-transport.vue'
class  PageTransportRequest extends PageRequest{
    keyword:string;
    transportType: string;
    transportStatus: string; 
}

@Component({
    components:{ViewTransport}
})
export default class Transport extends mixins(ListMixin, AbpBase){
    namespace = 'transport';
    pagerequest:PageTransportRequest=new PageTransportRequest();
    transportTypes=[];
    transportStatuses=[];
     get store () {
      return this.$store.state.transport;
    }
     isTenant() {
      return this.$store.state.session.tenant != null;
    }
    async getTransportTypes(){
        await this.$store.dispatch({
            type:'transport/getTransportTypes'
        }).then(()=>{
          this.transportTypes = this.$store.state.transport.transportTypes;
        });
    }
    async getTransportStatuses(){
       await this.$store.dispatch({
            type:'transport/getTransportStatuses'
        }).then(()=>{
          this.transportStatuses = this.$store.state.transport.transportStatuses;
        });
    }
    importTransports(){
        this.$router.push({path: '../grpwarehouse/import-transport'});
    }
    
    get list(){
      var re = this.$store.state.transport.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      
      return re;
    }
    columns= [
        ...transportcolumns
        ]
    async created(){
        await this.getTransportTypes();
        await this.getTransportStatuses();
    }
}
